import { useEffect, useRef, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import NumberFormat from "react-number-format";
import dayjs from "dayjs";
import {
  Button,
  Table,
  Spinner,
  Modal,
  Form,
  Row,
  Col,
  ButtonGroup,
  Alert,
  Collapse,
} from "react-bootstrap";
import { HiSearchCircle } from "react-icons/hi";

import { ArrowRight, Check, CheckCircle } from "react-bootstrap-icons";
import { useUser, useFirestore, useFunctions, useStorage } from "reactfire";
import { httpsCallable } from "firebase/functions";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  doc,
  orderBy,
  limit,
  collectionGroup,
  onSnapshot,
} from "firebase/firestore";
import CryptoJS from "crypto-js";
import { ErrorMessage, Formik, useField } from "formik";
import { ref, uploadBytesResumable } from "firebase/storage";
import * as Yup from "yup";
import StockCardSummaryRecon from "../helpers/StockCardSummaryRecon";

var relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const laneBase = require("../../assets/json/lane_base_d1_vic.json");
const externalYardOptions = laneBase?.lanes?.filter(
  (y) => y.activeInInspection === 1 || false
);

// let nextYardLocation = "VICRWC";
const WholesaleCategory = ["DW", "SYCF"];
const TradeCategory = ["TRADE"];

const defaultState = 1;

const defaultOptions = [
  { label: "Yes", value: 1 },
  { label: "No", value: 0 },
  { label: "N/A", value: -1 },
];

const formFieldsInspection = [
  {
    name: "serviceHistory",
    label: "Service History",
    type: "radio",
    active: true,
    options: [
      {
        label: "None",
        value: 0,
      },
      {
        label: "Partial",
        value: 1,
      },
      {
        label: "Full",
        value: 2,
      },
    ],
    required: true,
  },
  {
    name: "numberOfKeys",
    label: "Number of keys",
    type: "radio",
    active: true,
    options: [
      {
        label: "1",
        value: 1,
      },
      {
        label: "2",
        value: 2,
      },
    ],
  },
  {
    name: "externalScratchesOrDents",
    label:
      "External Scratches or dents (Panel shop, Paintless Dent Removal PDR, Touch up)",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "accidentSigns",
    label: "Any signs of being in an accident or accident repair?",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "frontTyres",
    label: "Front Tyre",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "frontPads",
    label: "Front Pads",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "frontDiscs",
    label: "Front Pads & Discs",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "frontSuspensionInspection",
    label: "Front Suspension inspection (External Mechanic)",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "rearTyres",
    label: "Rear Tyres",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "rearPads",
    label: "Rear Pads",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "rearDiscs",
    label: "Rear Pads & Discs",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "rearSuspensionInspection",
    label: "Rear Suspension Inspection (External Mechanic)",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  {
    name: "oilLeaks",
    label: "Oil Leaks (External Mechanic)",
    type: "radio",
    active: true,
    options: defaultOptions,
    required: true,
  },
  // {
  //   name: "serviceHistoryBooksAndKeys",
  //   label: "General – Service History/Books and keys",
  //   type: "radio",
  //   active: true,
  //   options: defaultOptions,
  //   required: true,
  // },
  {
    name: "photos",
    label: "Take photos",
    type: "photos",
    active: true,
  },
];

const timeRequiredByItem = {
  frontPads: 1,
  frontDiscs: 1.5,
  frontTyres: 1,
  rearPads: 1,
  rearDiscs: 1.5,
  rearTyres: 1,
  // wiperBlades: 0.25 - This is not in the form - check with Team
};

const validationSchemaInspection = Yup.object().shape(
  formFieldsInspection.reduce((schema, field) => {
    if (field.required && field.type !== "photos") {
      schema[field.name] = Yup.number().required("Required");
    }
    // if (field.type === "photos") {
    //   schema[field.name] = Yup.array().of(
    //     Yup.object().shape({
    //       name: Yup.string().required("Required"),
    //       size: Yup.number().required("Required"),
    //       type: Yup.string().required("Required"),
    //     })
    //   );
    // }
    return schema;
  }, {})
);

// const initState = formFieldsInspection.reduce((state, field) => {
//   state[field.name] = defaultState;
//   return state;
// }, {});

const initState = {};

const ReconVehicleDetailModalInspection = ({
  data,
  show,
  handleClose,
  createNew = false,
  stateFilter,
  buyingFilterUserRoles,
}) => {
  const [loading, setLoading] = useState(false);
  const [localData, setLocalData] = useState(data);

  const [saving, setSaving] = useState(false);
  const [refreshToggle, setRefreshToggle] = useState(false);

  const [numberOfKeys, setNumberOfKeys] = useState(null);
  const [serviceHistory, setServiceHistory] = useState(null);

  const [existingInspectionForm, setExistingInspectionForm] = useState([]);

  const [checklistOutcome, setChecklistOutcome] = useState(null);

  const [nextYardLocation, setNextYardLocation] = useState("VICRWC");

  //   Hooks
  const firestore = useFirestore();
  const user = useUser();
  const functions = useFunctions();
  const storage = useStorage();

  const photoRef = useRef(null);
  const [photos, setPhotos] = useState(null);
  const [photoError, setPhotoError] = useState(null);
  const [photoLoading, setPhotoLoading] = useState(false);

  const handleErrors = (error) => {
    console.log(error);
  };

  const handleSaveInspectionChecklist = async (values, setSubmitting) => {
    // if > 1 form exists, show confirmation modal
    if (existingInspectionForm.length > 0) {
      const confirm = window.confirm(
        "Have you updated the inspection checklist with the latest information?"
      );
      if (!confirm) {
        toast.error("Form not saved");
        return;
      }
    }
    setSaving(true);
    setSubmitting(true);
    console.log(values);

    console.log(data);
    console.log(user);

    //  Save to firebase storage for all photos
    const photoStorageMetadata = [];
    const photoPromises = [];
    if (photos) {
      for (let i = 0; i < photos.length; i++) {
        const file = photos[i];
        const storageRef = ref(
          storage,
          `reconditioning-process/${data?.veh?.VEHStockNumber}/${file.name}`
        );
        const uploadTask = uploadBytesResumable(storageRef, file);
        photoPromises.push(uploadTask);
      }
      await Promise.all(photoPromises)
        .then((snapshot) => {
          console.log("All photos uploaded successfully");
          snapshot.forEach((snap) => {
            const photoMetadata = {
              name: snap.metadata.name,
              fullPath: snap.metadata.fullPath,
              size: snap.metadata.size,
              type: snap.metadata.contentType,
              timeCreated: snap.metadata.timeCreated,
              updated: snap.metadata.updated,
              downloadURL: snap.metadata.fullPath,
            };
            photoStorageMetadata.push(photoMetadata);
          });
          toast.success("Photos uploaded successfully");
        })
        .catch((error) => {
          console.error("Error uploading photos: ", error);
          toast.error("Error uploading photos");
        });
    }
    // Get photo metadata and create an array of photo URLs

    // Delete photos from values
    values.photos = null;

    const qcChecklistPayload = {
      ...values,
      photos: photoStorageMetadata,
      createdBy: user?.data?.displayName,
      createdByEmail: user?.data?.email,
      createdByPhone: user?.data?.phoneNumber,
      createdById: user?.data?.uid,
      createdAt: dayjs().unix(),
      vin: data?.veh?.VEHVIN,
      stockNumber: data?.veh?.VEHStockNumber,
      branchId: data?.veh?.BranchId,
      branchName: data?.veh?.Branch,
      make: data?.veh?.VEHMake,
      model: data?.veh?.VEHmodel,
      year: data?.veh?.VEHModelYear,
      yard: data?.veh?.VEHYard,
      odometer: data?.veh?.VEHOdo,
    };

    console.log(qcChecklistPayload);
    // Create an md5 hash of VEHStockNumber and VEHVIN
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);

    const qcChecklistRef = await addDoc(
      collection(
        firestore,
        "reconditioning-process",
        hash,
        "recon-form-inspection"
      ),
      qcChecklistPayload
    )
      .then(async (r) => {
        toast.success("Saved form");
        await pushToNextYardLocation();
        setRefreshToggle((prev) => !prev);
      })
      .catch((e) => {
        toast.error("Error saving form");
        console.log(e);
      });

    setSaving(false);
    setSubmitting(false);
  };

  const pushToNextYardLocation = async () => {
    setLoading(true);
    const lt = toast.loading("Updating yard location...");
    const yardLocation = nextYardLocation;
    const yardLocationComments = `Changed by ${user.data.displayName} from ${data?.veh?.VEHYard} to ${yardLocation}`;

    const payload = {
      selectedVehicle: data?.veh,
      comments: yardLocationComments,
      createdAt: dayjs().format("YYYY-MM-DD"),
      createdBy: user.data.displayName,
      VEHStockNumber: data?.veh?.VEHStockNumber,
      VIN: data?.veh?.VEHVIN,
      originalBranch: data?.veh?.Branch,
      yardLocation: yardLocation,
      EclipseDBName: data?.veh?.db,
      EclipseBranchID: data?.veh?.BranchId,

      actioned: false,
      actionStatus: null,
      actionedTimestamp: null,
      action: "GENERAL_YARD_LOG_UPDATE",
    };

    // Callable function
    const yardChangeLogRequestD1VIC = httpsCallable(
      functions,
      "yardChangeLogRequestD1VIC"
    );

    await yardChangeLogRequestD1VIC({
      yardChangeData: payload,
      selectedVehicle: data?.veh,
    })
      .then((r) => {
        console.log(r);
        if (r.data.status === "success") {
          toast.success("Yard location update queued");
          toast.success(
            "Yard log should update to Inspection in Eclipse in 5 minutes"
          );
        } else {
          toast.error("Yard location update failed");
        }
      })
      .catch((e) => {
        toast.error(e.message);
      });
    setLoading(false);
    toast.dismiss(lt);
  };

  const pushDetailingCostEstimate = async () => {
    setLoading(true);
    const lt = toast.loading("Updating detailing cost estimate...");
    const yardLocation = "DETAILING";
    const cost_detailing_standard = 220 / 1.1;
    const yardLocationComments = `Standard detailing cost estimate of $${
      220 / 1.1
    }`;
    const client_id_SKAJB = 15748;

    const payload = {
      selectedVehicle: data?.veh,
      comments: yardLocationComments,
      createdAt: dayjs().format("YYYY-MM-DD"),
      createdBy: user.data.displayName,
      VEHStockNumber: data?.veh?.VEHStockNumber,
      VIN: data?.veh?.VEHVIN,
      originalBranch: data?.veh?.Branch,

      carrierEstimateCost: cost_detailing_standard,

      yardLocation: yardLocation,
      EclipseDBName: data?.veh?.db,
      EclipseBranchID: data?.veh?.BranchId,
      CarrierSupplierID: client_id_SKAJB,

      actioned: false,
      actionStatus: null,
      actionedTimestamp: null,
      action: "FREIGHT_COST_UPDATE",
    };

    // Callable function
    const yardChangeLogRequestD1VIC = httpsCallable(
      functions,
      "yardChangeLogRequestD1VIC"
    );

    await yardChangeLogRequestD1VIC({
      yardChangeData: payload,
      selectedVehicle: data?.veh,
    })
      .then((r) => {
        console.log(r);
        if (r.data.status === "success") {
          toast.success("Yard location update queued");
          toast.success(
            "Yard log should update to Inspection in Eclipse in 5 minutes"
          );
        } else {
          toast.error("Yard location update failed");
        }
      })
      .catch((e) => {
        toast.error(e.message);
      });
    setLoading(false);
    toast.dismiss(lt);
  };

  // On mount load any existing arrival forms
  useEffect(() => {
    const stockVin = `${data?.veh.VEHStockNumber}${data?.veh.VEHVIN}`;
    const hash = CryptoJS.MD5(stockVin).toString();
    console.log(stockVin, hash);
    const arrivalChecklistRef = collection(
      firestore,
      "reconditioning-process",
      hash,
      "recon-form-inspection"
    );
    const q = query(arrivalChecklistRef, orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const arrivalForms = [];
      querySnapshot.forEach((doc) => {
        arrivalForms.push({ id: doc.id, ...doc.data() });
      });
      console.log(arrivalForms);
      setExistingInspectionForm(arrivalForms);
    });
    return () => {
      unsubscribe();
    };
  }, [JSON.stringify(data), refreshToggle]);

  useEffect(() => {
    // Refresh the data when the modal state changes or refreshToggle changes
    setLocalData(data);
    setExistingInspectionForm([]);
  }, [show, refreshToggle]);

  return (
    <Modal show={show} size="xl" onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <h5>
            {data?.veh?.VEHStockNumber} -{" "}
            {`${data?.veh?.VEHModelYear} ${data?.veh?.VEHMake} ${data?.veh?.VEHmodel} ${data?.veh?.Variant}`}
          </h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <h4>Inspection checklist</h4>
            {existingInspectionForm.length > 0 && (
              <div>
                <h5>Existing saved forms</h5>
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Created At</th>
                      <th>Created By</th>
                      {/* <th>Outcome</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {existingInspectionForm.map((form) => {
                      return (
                        <tr key={form.id}>
                          <td>
                            {dayjs
                              .unix(form.createdAt)
                              .format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td>{form.createdBy}</td>
                          {/* <td>
                            {form.checklistOutcome === 1 ? (
                              <CheckCircle
                                style={{ color: "green", fontSize: 20 }}
                              />
                            ) : form.checklistOutcome === 0 ? (
                              <div style={{ color: "red" }}>Failed</div>
                            ) : null}
                          </td> */}
                          {/* <td>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => {
                                // setLocalData(form);
                                // setShowArrivalForm(true);
                              }}
                            >
                              View
                            </Button>
                          </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}
            <Formik
              initialValues={initState}
              enableReinitialize={true}
              validateOnSubmit={true}
              validateOnChange={true}
              validationSchema={validationSchemaInspection}
              onSubmit={(values, { setSubmitting }) =>
                handleSaveInspectionChecklist(values, setSubmitting)
              }
            >
              {({
                values,
                errors,
                isSubmitting,
                handleSubmit,
                handleChange,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  {formFieldsInspection.map((field, index) => {
                    if (field.type === "radio") {
                      return (
                        <Form.Group
                          key={index}
                          controlId={field.name}
                          style={{
                            marginTop: 10,

                            // alternate background color
                            backgroundColor:
                              index % 2 === 0 ? "#f8f9fa" : "#fff",
                            padding: 10,
                          }}
                        >
                          <Form.Label>{field.label}</Form.Label>
                          <ButtonGroup
                            style={{ flexWrap: "wrap", float: "right" }}
                          >
                            {field.options.map((option, index) => {
                              return (
                                <Button
                                  key={index}
                                  variant={
                                    values[field.name] === option.value
                                      ? "primary"
                                      : "outline-primary"
                                  }
                                  onClick={() =>
                                    setFieldValue(field.name, option.value)
                                  }
                                >
                                  {option.label}
                                </Button>
                              );
                            })}
                          </ButtonGroup>

                          {errors[field.name] ? (
                            <div
                              style={{
                                color: "red",
                                fontSize: 12,
                                marginTop: 5,
                                float: "right",
                                marginRight: 10,
                              }}
                            >
                              {errors[field.name]}
                            </div>
                          ) : null}
                        </Form.Group>
                      );
                    }
                    if (field.type === "photos") {
                      return (
                        <Form.Group
                          key={index}
                          controlId={field.name}
                          style={{
                            marginTop: 10,
                            backgroundColor:
                              index % 2 === 0 ? "#f8f9fa" : "#fff",
                            padding: 10,
                          }}
                        >
                          <Form.Label>{field.label}</Form.Label>
                          <Button
                            variant="outline-warning"
                            size="sm"
                            style={{ marginRight: 10, float: "right" }}
                            onClick={() => {
                              // Take multiple photos
                              photoRef.current.click();
                            }}
                          >
                            Take photos
                          </Button>
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            ref={photoRef}
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const files = e.target.files;
                              const fileArray = Array.from(files);
                              console.log(fileArray);
                              // Set photos and add to previous photos
                              if (values[field.name]) {
                                setFieldValue(field.name, [
                                  ...values[field.name],
                                  ...fileArray,
                                ]);
                              } else {
                                setFieldValue(field.name, fileArray);
                              }
                              setPhotos(fileArray);
                            }}
                          />
                          {values[field.name] && (
                            <div>
                              {values[field.name].map((file, index) => {
                                return (
                                  <div key={index}>
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt="photo"
                                      style={{
                                        // width: 100,
                                        fit: "contain",
                                        height: 100,
                                        marginRight: 10,
                                        marginBottom: 10,
                                      }}
                                    />
                                    <Button
                                      variant="danger"
                                      size="sm"
                                      onClick={() => {
                                        // Remove photo
                                        const newPhotos = values[
                                          field.name
                                        ].filter((f, i) => i !== index);
                                        setFieldValue(field.name, newPhotos);
                                      }}
                                      style={{
                                        position: "absolute",
                                        marginLeft: 10,
                                        // marginTop: -20,
                                      }}
                                    >
                                      X
                                    </Button>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </Form.Group>
                      );
                    }
                  })}

                  {/* Options for externalYardLocations */}
                  <Form.Group
                    controlId="form-external-yard-location"
                    style={{ marginTop: 10 }}
                  >
                    <Form.Label>
                      Where are you sending this car next?
                    </Form.Label>
                    <Form.Control
                      as="select"
                      name="externalYardLocation"
                      onChange={(e) => {
                        setNextYardLocation(e.target.value);
                      }}
                      defaultValue={nextYardLocation}
                    >
                      {externalYardOptions.map((option, index) => {
                        return (
                          <option key={index} value={option.id}>
                            {option.title}
                          </option>
                        );
                      })}
                    </Form.Control>
                  </Form.Group>
                  {/* <pre>{JSON.stringify(externalYardOptions, null, 2)}</pre> */}

                  <Row style={{ marginTop: 10 }}>
                    <Col>
                      <ButtonGroup>
                        <Button
                          variant="primary"
                          type="submit"
                          id="frm-submit-btn"
                          disabled={isSubmitting}
                          size="sm"
                        >
                          Save and send to {nextYardLocation}
                        </Button>
                        <Button onClick={handleClose} variant="secondary">
                          Close
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                  <Collapse in={isSubmitting}>
                    <Row style={{ marginTop: 10 }}>
                      <Col>
                        <Spinner animation="border" role="status">
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </Col>
                    </Row>
                  </Collapse>
                </form>
              )}
            </Formik>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <StockCardSummaryRecon
          veh={data?.veh}
          yardLogs={data?.veh?.yardLogs || []}
        />
        {/* {JSON.stringify(data, null, 2)} */}
      </Modal.Footer>
    </Modal>
  );
};

export default ReconVehicleDetailModalInspection;
